import ClassManager from "./ClassManager";

export default ClassManager;
export { ClassManager };
